import { fetchJson } from '@/client/utils'

export const searchPages = async (locale: string, value?: string, section?: string) => {
  const apiUrl = process.env.NEXT_PUBLIC_API_CMS || ''
  let printfilerrorskey = ''
  switch (true) {
    case apiUrl.includes('https://it.cms.etikett.de/'):
      printfilerrorskey = 'errori-comuni-nei-fi'
      break
    case apiUrl.includes('https://es.cms.etikett.dev/'):
      printfilerrorskey = 'print-file-error'
      break
    default:
      printfilerrorskey = 'print-file-error'
  }
  let url = `${apiUrl}/search?per_page=5&subtype=page,${section},blog,custom-page,success-stories,tutorial,${printfilerrorskey}&search=${value}`

  if (!apiUrl?.includes(locale)) {
    url = url + `&lang=${locale}`
  }

  const data = await fetchJson(url)
  return data
}
export const searchBlog = async (locale: string, value?: string) => {
  const apiUrl = process.env.NEXT_PUBLIC_API_CMS
  let url = `${apiUrl}/blog?per_page=3&exclude=${value}&acf_format=standard`

  if (!apiUrl?.includes(locale)) {
    url = url + `&lang=${locale}`
  }

  const data = await fetchJson(url)
  const resData = data.map((e) => ({
    date: e['date'],
    link: e['link'],
    ...e['acf']
  }))
  return resData
}
export const getToolsData = async () => {
  const apiUrl = process.env.NEXT_PUBLIC_API_CMS
  const url = `${apiUrl}/pages?slug=tools`

  const res = await fetch(url)
  const [data] = await res.json()
  return data?.acf
}
export const getMedia = async (locale: string, value?: number) => {
  const apiUrl = process.env.NEXT_PUBLIC_API_CMS
  const url = `${apiUrl}/media/${value}`

  const res = await fetch(url)
  const data = await res.json()
  const { source_url, media_details } = data
  return { source_url, media_details }
}
